import server from '../statics/server.js'
import axios from 'axios'
import ModalEmail from '../modals/ModalEmail.vue'
import ModalNote from '../modals/ModalNote.vue'
import ModalSms from '../modals/ModalSms.vue'
import ModalUserUnify from '../modals/ModalUserUnify.vue'
import ModalUserRegisterExcel from '../modals/ModalUserRegisterExcel.vue'

// user1 list 에서 공통적으로 사용되는 부분
export default {
	components: {
		ModalEmail,
		ModalNote,
		ModalSms,
		ModalUserUnify,
		ModalUserRegisterExcel
	},
	methods: {
		// 유저 클릭 시
		selectMemberData: function(member) {
			this.selectedMember = this.selectedMember == member ? null : member;
		},
		// 전체 유저 체크 선택
		checkAllUsers: function() {
			const isCheckedAll = this.members.reduce((prev, curr) => (
				prev && curr.isChecked ? true : false
			), true); // 전체가 선택되어있는지 검색

			this.members.forEach(member => {
				this.$set(member, "isChecked", !isCheckedAll);
			});
		},
		// 유저삭제
		deleteMemberData: function(index) {
			this.modals.ModalConfirm.msg = "선택한 회원을 탈퇴처리 하시겠습니까?";
			this.modals.ModalConfirm.show = true;
			this.modals.ModalConfirm.btnYes.fn = async () => {
				try {
					const targetMember = this.members[index];

					//만약 선택되어 선택을 리셋해줌.
					if(this.selectedMember === targetMember) this.selectedMember = null;
					await axios.delete(`${server.addr()}${server.api.MBER}/${targetMember.mberId}`);

					this.onRefresh();
				} catch(e) {
					this.modals.ModalAlert.msg = "통신에러! 잠시 후 다시 시도해주세요.";
					this.modals.ModalAlert.show = true;
				}
				this.modals.ModalConfirm.show = false;
			}
		},
		// 헤더에서 회원등록 버튼 클릭시
		onUserRegister: function() {
			this.modals.ModalUserRegister.show = true;
		},
		// 헤더에서 일괄등록 버튼 클릭시
		onUserRegisterExcel: function() {
			this.modals.ModalUserRegisterExcel.show = true;
		},
		// 회원목록에서 회원통합 버튼 클릭시
		onIntegration: function() {
			const userList = this.members.filter(e=>e.isChecked);
			if(userList.length <= 1) {
				this.modals.ModalAlert.msg = "통합할 회원을 2명 이상 선택해야 합니다.";
				this.modals.ModalAlert.show = true;
				return;
			}
			this.modals.ModalUserUnify.userList = userList;
			this.modals.ModalUserUnify.show = true;
		},
		onNote: function(selectedMember) {
			this.modals.ModalNote.sendList = [{name: selectedMember.mberName, mberId: selectedMember.mberId}];
			this.modals.ModalNote.show = true;
		},
		onSms: function(selectedMember) {
			this.modals.ModalSms.sendList = [{name: selectedMember.mberName, mobileNum: selectedMember.mobileNum}];
			this.modals.ModalSms.show = true;
		},
		onEmail: function(selectedMember) {
			this.modals.ModalEmail.sendList = [{name: selectedMember.mberName, email: selectedMember.email}];
			this.modals.ModalEmail.show = true;
		},
		// 회원목록에서 쪽지발송 버튼 클릭시
		onNoteForm: function(isChecked, target) {
			let sendList = [];
			if(target) {
				sendList = target;
			} else {
				if(isChecked) {
					sendList = this.members.filter(e=>e.isChecked).map(e=>{
						return {name: e.mberName, mobileNum: e.mobileNum, mberId: e.mberId}
					});
				} else {
					sendList = this.members.map(e=>{
						return {name: e.mberName, mobileNum: e.mobileNum, mberId: e.mberId}
					});
				}
			}
			this.modals.ModalNote.sendList = sendList;
			this.modals.ModalNote.show = true;
		},
		// 회원목록에서 SMS발송 버튼 클릭시
		onSMSForm: function(isChecked, target) {
			let sendList = [];
			if(target) {
				sendList = target;
			} else {
				if(isChecked) {
					sendList = this.members.filter(e=>e.isChecked).map(e=>{
						return {name: e.mberName, mobileNum: e.mobileNum, mberId: e.mberId}
					});
				} else {
					sendList = this.members.map(e=>{
						return {name: e.mberName, mobileNum: e.mobileNum, mberId: e.mberId}
					});
				}
			}
			this.modals.ModalSms.sendList = sendList;
			this.modals.ModalSms.show = true;
		},
		// 회원목록에서 메일발송 버튼 클릭시
		onMailForm: function(isChecked, target) {
			let sendList = [];
			if(target) {
				sendList = target;
			} else {
				if(isChecked) {
					sendList = this.members.filter(e=>e.isChecked).map(e=>{
						return {name: e.mberName, email: e.email, mberId: e.mberId}
					});
				} else {
					sendList = this.members.map(e=>{
						return {name: e.mberName, email: e.email, mberId: e.mberId}
					});
				}
			}
			this.modals.ModalEmail.sendList = sendList;
			this.modals.ModalEmail.show = true;
		},
		// 필터 리스트
		changeFilters: function(filterList) {
			this.filterList = filterList;

			this.getMemberData();
		},
		// pageSize 지정
		onPageSize: function($event) {
			this.pageSize = parseInt($event.target.value);

			this.getMemberData();
		},
		// sort 방식 지정
		onOrderBy: function($event) {
			this.orderBy = parseInt($event.target.value);

			this.getMemberData();
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getMemberData();
		},
		// 등록 및 삭제후 refresh
		onRefresh: function() {
			this.getMemberData();
		},
		// 서브클레스에서 confirm띄울때
		onConfirm: function(options) {
			this.modals.ModalConfirm.msg = options.message;
			this.modals.ModalConfirm.btnYes.name = "확인";
			this.modals.ModalConfirm.btnYes.fn = () => {
				options.yesCb();
				this.modals.ModalConfirm.show = false;
			};

			this.modals.ModalConfirm.btnNo.name = "취소";
			this.modals.ModalConfirm.btnNo.fn = () => {
				if(typeof options.noCb === "function") options.noCb();
				this.modals.ModalConfirm.show = false;
			};

			this.modals.ModalConfirm.show = true;
		},
		// 서브클레스에서 alert 띄울때 사용한는 함수
		onDone: function(message) {
			this.modals.ModalAlert.msg = message;
			this.modals.ModalAlert.show = true;
		}
	},
	computed: {
		// 전체가 선택되어 있는지 확인하는 함수
		isCheckedAll: function() {
			const isCheckedAll = this.members.reduce((prev, curr) => (
				prev && curr.isChecked ? true : false
			), true); // 전체가 선택되어있는지 검색

			return isCheckedAll;
		}
	}
}